module.exports = __webpack_public_path__ + "76be2cdf69c3b67d2854dcf3187c3413.woff2";